import { Component, Input, OnInit } from '@angular/core';
import { AnchorModel } from 'src/app/shared/models/node';

@Component({
  selector: 'app-page-custom',
  templateUrl: './page-custom.component.html',
  styleUrls: ['./page-custom.component.scss']
})
export class PageCustomComponent implements OnInit {

  @Input() node: any;
  public anchorItems: AnchorModel[] = [];
  public idAnchor: string = '';
  public isSpinner: boolean = false;

  constructor() { }
  
  ngOnInit(): void {
    this.isSpinner = true;
    // setTimeout(() => {
    //   this.isSpinner = true;
    // }, 400);
  }

  addNewAnchorItem(value: AnchorModel){
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    this.idAnchor = this.anchorItems[0].idRow;
  }

}
